import axios from 'axios';
import FileSaver from 'file-saver';
import { Observable } from 'rxjs';
import store from './store';

const API = '/api';

const handleErrors = error => {
  const response = error.response;
  if (response && !response.ok) {
    // if (response.status === 401) {
    //   window.location.href = '/auth/login';
    // }
    const messages = {};
    if (response.data.errors) {
      response.data.errors.forEach(error => messages[error.field] = error.defaultMessage);
    }
    store.dispatch('addNotification', { text: response.statusText, type: 'error' });
    return Promise.reject({
      status: `${response.status} ${response.statusText}`,
      messages
    });
  }
  store.dispatch('addNotification', { text: error, type: 'error' });
  return Promise.reject(error);
};

const getFilename = dispositionHeader => {
  const regex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = regex.exec(dispositionHeader);
  if (matches && matches[1]) {
    return matches[1].replace(/['"]/g, '');
  }
  return dispositionHeader;
};

axios.interceptors.request.use(
    config => {
      config.url = API + config.url;
      return config;
    },
    error => Promise.reject(error)
);

axios.interceptors.response.use(
    response => response,
    handleErrors
);

export const post = (uri, data) => axios.post(uri, data);

export const put = (uri, data) => axios.put(uri, data);

export const patch = (uri, data) => axios.patch(uri, data);

export const get = uri => axios.get(uri);

export const remove = uri => axios.delete(uri);

export const file = uri => {
  return new Observable(subscriber => {
    axios.get(
        uri,
        {
          responseType: 'blob',
          onDownloadProgress: progressEvent => subscriber.next(
              Number(Math.round((progressEvent.loaded / progressEvent.total) * 100)))
        })
    .then(response => FileSaver.saveAs(new Blob([response.data]), getFilename(response.headers['content-disposition'])))
    .then(() => subscriber.complete());
  });
};
